import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useApi } from "./useApi";

export const useDeleteRole = (options: UseMutationOptions<unknown, unknown, string, unknown> = {}) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  if (!organizationId || !sport) {
    throw new Error(
      `OrganizationId or sport not found in route params. organizationId: ${organizationId}, sport: ${sport}`,
    );
  }

  return useMutation({
    mutationFn: (roleId: string) => request(`${sport}/o/${organizationId}/roles/${roleId}`, { method: "DELETE" }),
    ...options,
  });
};
